<template>
  <div :class="{ 'dboard-filter': isDarkTheme }">
    <div class="row primary-filter">
      <div class="col-md-auto filter-grid">
        <ul class="inlinelist">
          <li class="app-side-menu">
            <span @click="isOpen = true" class="pointer">
              <svgicon
                :name="isDarkTheme ? 'menu-light' : 'menu'"
                width="20"
                height="20"
                :original="true"
                class="menu"
              />
            </span>
            <div class="sidemenu-slideout" :class="{ isOpen: isOpen }">
              <Sidebar @close="isOpen = false" />
            </div>
          </li>
          <li
            class="color-changes category"
            :class="{ 'border-dark': isDarkTheme }"
            v-if="menuOptionsList"
          >
            <FilterDropdown
              v-if="menuOptionsList.length"
              :options="menuOptionsList"
              :selected="selectedCategory"
              :isDarkTheme="isDarkTheme"
              @updateOption="onChangeOption"
            />
          </li>
        </ul>
      </div>
      <div class="col filter-grid">
        <div class="row" v-if="!noSearchFilter">
          <div class="col">
            <div class="app-search-label">
              <div v-if="showPopup">
                <SearchPopup
                  v-if="showPopup"
                  :searchParameters="searchParameters"
                  :presearchedParams="preSearchedParams"
                  @closePopup="closePopup"
                  @search="searchByParameter"
                  :isDarkTheme="isDarkTheme"
                />
              </div>
              <div
                class="searchterm tagblock"
                v-if="!showPopup"
                @click="onClick"
                :class="{ pointer: noParams }"
              >
                <svgicon
                  name="search-dark"
                  width="15"
                  height="15"
                  :original="true"
                  v-if="isDarkTheme"
                />
                <svgicon
                  name="search"
                  width="15"
                  height="15"
                  :original="true"
                  v-else
                />
                <input
                  type="text"
                  :placeholder="searchText"
                  v-on:keyup="search"
                  id="search_key"
                  v-model="query"
                  v-if="!enableSearchPopup"
                />
                <span type="text" class="tagblock_list" v-else>
                  <span
                    v-for="(value, name, index) in displaySearchParams"
                    :key="index"
                  >
                    <span
                      v-if="
                        value && multiSearchFields.includes(name)
                      "
                    >
                      <Tag closable @close="removeParamTag(name)">
                        <div class="searchtag-title">
                          {{ getTagByName(name) }}
                        </div>
                        <span v-if="value.length === 1">
                          {{ dataToShow(value) }}
                        </span>
                        <Tooltip
                          v-else
                          popper-class="max-width"
                          :open-delay="200"
                          effect="dark"
                          placement="bottom-start"
                        >
                          <div slot="content">{{ dataOnHover(value) }}</div>
                          <span class="pointer">{{ dataToShow(value) }}</span>
                        </Tooltip>
                      </Tag>
                    </span>
                    <span v-else-if="value">
                      <Tag closable @close="removeParamTag(name)">
                        <div class="searchtag-title">
                          {{ getTagByName(name) }}
                        </div>
                        {{ value }}
                      </Tag>
                    </span>
                  </span>
                  <span v-if="noParams" class="inputtextlabel">{{
                    searchText
                  }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-auto filter-grid">
        <FilterDropdown
          v-if="languages.length > 1 && selectedLanguage"
          :options="languages"
          :selected="selectedLanguage"
          v-on:updateOption="updateLanguage"
        />
      </div>
      <div class="col-md-auto filter-grid filter-button">
        <span>
          <ul class="filter-btn-group inlinelist">
            <li v-for="button in buttonsList" :key="button.id">
              <span v-if="button.show && canShowPermission(button)">
                <router-link
                  v-if="button.routerLinkName"
                  :to="getRouterLink(button)"
                  class="ml-15"
                >
                  <button
                    class="btn"
                    :class="button.class"
                    @click="setGA(button)"
                  >
                    {{ button.tlabel ? $t(button.tlabel) : button.name }}
                  </button>
                </router-link>
                <Tooltip
                  v-else-if="button.disableTooltip && button.disabled"
                  effect="dark"
                  placement="bottom-start"
                >
                  <div slot="content">{{ button.disableTooltip }}</div>
                  <span class="pointer">
                    <button
                      class="btn"
                      :class="getClass(button)"
                      :disabled="button.disabled"
                      @click="$emit(button.emitMethod)"
                    >
                      {{ button.tlabel ? $t(button.tlabel) : button.name }}
                    </button>
                  </span>
                </Tooltip>
                <Dropdown
                  v-else-if="button.dropdownList && !isUploading"
                  trigger="click"
                  @visible-change="toggleButton(button.id)"
                  :class="{
                    dropdownbutton: dropdownOpen && dropdownOpen[button.id],
                  }"
                >
                <button
                  v-if="(button.name.toLowerCase() === 'upload' && selectedCategory && selectedCategory.is_bulk_upload_v2)"
                  type="primary"
                  class="btn btn-secondary"
                  :class="button.class"
                  @click="routeToMdmUploadPage()"
                >
                  {{ button.tlabel ? $t(button.tlabel) : button.name }}
                </button>
                <button
                v-else
                    type="primary"
                    class="btn btn-secondary"
                    :class="button.class"
                  >
                    {{ button.tlabel ? $t(button.tlabel) : button.name }}
                    <svgicon
                      name="categorydropdown"
                      class="dropdown-icon"
                      width="10"
                      height="10"
                      :original="true"
                    />
                  </button>
                  <Dropdown-menu slot="dropdown" :class="button.dropdownClass">
                    <Dropdown-item
                      v-for="(dropdownItem, index) in getButtonDropdownlist(
                        button
                      )"
                      :key="index"
                    >
                      <span
                        v-if="
                          dropdownItem.type === 'upload' &&
                          !selectedCategory.is_bulk_upload_v2
                        "
                      >
                        <label>
                          <input
                            class="upload-material"
                            type="file"
                            id="file"
                            :ref="dropdownItem.uploadEmitMethod"
                            :accept="`${AttachmentConstants.excelMimes}`"
                            @change="
                              handleFileUpload(dropdownItem.uploadEmitMethod)
                            "
                          />
                          <span class="action">{{
                            dropdownItem.tlabel
                              ? $t(dropdownItem.tlabel)
                              : dropdownItem.name
                          }}</span>
                        </label>
                        <a
                          :href="`${$asset_path}static/sample/${dropdownItem.sampleFileName}`"
                          v-if="dropdownItem.sampleFileName"
                          download
                          class="format-text"
                          target="_blank"
                          >Sample format</a
                        >
                        <a
                          href="javascript:void(0)"
                          @click="$emit(dropdownItem.sampleFileEmitMethod)"
                          v-else
                          class="format-text"
                          >Sample format</a
                        >
                      </span>

                      <span
                        v-if="
                          dropdownItem.type === 'link' &&
                          hasConfiguration(dropdownItem, button.parentConfig)
                        "
                      >
                        <label>
                          <li class="select_options">
                            <router-link
                              v-if="dropdownItem.routerLinkName"
                              :to="getRouterLink(dropdownItem)"
                            >
                              <a href="#" class="action">{{
                                dropdownItem.tlabel
                                  ? $t(dropdownItem.tlabel)
                                  : dropdownItem.name
                              }}</a>
                            </router-link>
                          </li>
                        </label>
                      </span>
                      <span v-if="dropdownItem.type === 'button'">
                        <label>
                          <li class="select_options">
                            <a
                              href="#"
                              class="action"
                              @click="$emit(dropdownItem.emitMethod)"
                              >{{
                                dropdownItem.tlabel
                                  ? $t(dropdownItem.tlabel)
                                  : dropdownItem.name
                              }}</a
                            >
                          </li>
                        </label>
                      </span>
                      <span
                        v-if="
                          dropdownItem.type === 'export' &&
                          (!dropdownItem.permission ||
                            $hasPermission(dropdownItem.permission))
                        "
                      >
                        <label>
                          <li class="select_options">
                            <a
                              href="javascript:void(0)"
                              class="action"
                              @click="
                                $emit(dropdownItem.emitMethod, dropdownItem.id)
                              "
                              >{{
                                dropdownItem.tlabel
                                  ? $t(dropdownItem.tlabel)
                                  : dropdownItem.name
                              }}</a
                            >
                          </li>
                        </label>
                      </span>
                    </Dropdown-item>
                    <Dropdown-item
                      v-for="(upload, idx) in additionalUpload(button)"
                      :key="`additional-upload-key-${idx}`"
                    >
                      <label v-if="!selectedCategory.is_bulk_upload_v2">
                        <input
                          class="upload-material"
                          type="file"
                          id="file"
                          :ref="upload.uploadEmitMethod"
                          :accept="`${AttachmentConstants.excelMimes}`"
                          @change="handleFileUpload(upload.uploadEmitMethod)"
                        />
                        <span class="action">{{
                          upload.tlabel ? $t(upload.tlabel) : upload.name
                        }}</span>
                      </label>
                      <a
                        :href="`${$asset_path}static/sample/${upload.sampleFileName}`"
                        v-if="upload.sampleFileName"
                        download
                        class="format-text"
                        target="_blank"
                      >
                        {{ $t('MDM_SAMPLE_FORMAT') }}
                      </a>
                      <a
                        v-if="upload.getExcelFromAPI"
                        href="javascript:void(0)"
                        @click="$emit('getAdditionalExcelHeader')"
                        class="format-text"
                        >{{ $t('MDM_SAMPLE_FORMAT') }}</a
                      >
                    </Dropdown-item>
                  </Dropdown-menu>
                </Dropdown>
                <Dropdown
                  v-else-if="
                    button.dropdownList && isUploading && button.id === 'export'
                  "
                  trigger="click"
                  @visible-change="toggleButton(button.id)"
                  :class="{
                    dropdownbutton: dropdownOpen && dropdownOpen[button.id],
                  }"
                >
                  <Dropdown-menu slot="dropdown" :class="button.dropdownClass">
                    <Dropdown-item
                      v-for="(dropdownItem, index) in getButtonDropdownlist(
                        button
                      )"
                      :key="index"
                    >
                      <span
                        v-if="
                          dropdownItem.type === 'export' &&
                          (!dropdownItem.permission ||
                            $hasPermission(dropdownItem.permission))
                        "
                      >
                        <label>
                          <li class="select_options">
                            <a
                              href="javascript:void(0)"
                              class="action"
                              @click="
                                $emit(dropdownItem.emitMethod, dropdownItem.id)
                              "
                              >{{
                                dropdownItem.tlabel
                                  ? $t(dropdownItem.tlabel)
                                  : dropdownItem.name
                              }}</a
                            >
                          </li>
                        </label>
                      </span>
                    </Dropdown-item>
                  </Dropdown-menu>
                </Dropdown>
                <Processing
                  v-else-if="
                    button.dropdownList && isUploading && button.id !== 'export'
                  "
                  background="#0073FF"
                  size="30px"
                />
                <button
                  v-else
                  class="btn"
                  :class="getClass(button)"
                  :disabled="button.disabled"
                  @click="$emit(button.emitMethod)"
                >
                  {{ button.tlabel ? $t(button.tlabel) : button.name }}
                </button>
              </span>
            </li>
          </ul>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { bulkUploadList } from 'pando-constants';
import FilterDropdown from '@common/components/FilterDropdown';
import SearchPopup from '@common/components/SearchPopup';
import AttachmentConstants from '@common/constants/AttachmentConstants';
import { bfrMapper } from '../../constants/mdm-v2/pageConstants';
import debounce from 'debounce';
import Sidebar from './Sidebar';

import setLocale from '@/utils/localisation';

export default {
  name: 'PrimaryFilterr',
  props: {
    searchText: { type: String },
    menuOptions: { type: Array },
    selectedCategory: { type: Object },
    queryParams: { type: String },
    buttonsList: { type: Array },
    noSearchFilter: { type: Boolean },
    isUploading: { type: Boolean },
    enableSearchPopup: { type: Boolean },
    searchParameters: { type: Array },
    preSearchedParams: { type: Object },
    isDarkTheme: { type: Boolean },
    additionalUploads: { type: Array },
  },
  components: {
    Sidebar,
    FilterDropdown,
    SearchPopup,
  },
  data() {
    return {
      query: null,
      isOpen: false,
      focusSearch: true,
      dropdownOpen: null,
      AttachmentConstants,
      showPopup: false,
      searchedParams: {},
      displaySearchParams: {},
      selectedLanguage: null,
      displayLabels: {},
      multiSearchFields: ['source', 'destination', 'sourceRefIds', 'destinationRefIds',
        'sourceNames', 'destinationNames'],
    };
  },
  computed: {
    ...mapGetters({
      configurations: 'app/configurations',
    }),

    noParams() {
      return Object.values(this.displaySearchParams).every(
        parameter => !parameter,
      );
    },
    isMdmPage() {
      return this.menuOptions && this.menuOptions[0].id === 'MDM';
    },
    menuOptionsList() {
      return this.menuOptions && this.menuOptions.filter((menu) => {
        if (menu && menu.feature) {
          return this.$hasFeature(menu.feature);
        } return true;
      });
    },
    languages() {
      const locales =
        (this.configurations &&
          this.configurations.locales &&
          this.configurations.locales.allowed_locales) ||
        [];
      return locales;
    },
    defaultLanguage() {
      const preSelectedLocale = localStorage.getItem('tsm-shipper-locale');
      const defaultLocale =
        this.configurations &&
        this.configurations.locales &&
        this.configurations.locales.default_locale;
      const localeName = this.configurations && this.configurations.locales && this.configurations.locales.allowed_locales.find(locale => locale.id === (preSelectedLocale || defaultLocale)).name;
      return preSelectedLocale || localeName;
    },
    additionalUpload() {
      return button => button.id !== 'export' && this.additionalUploads;
    },
  },
  async created() {
    if (this.preSearchedParams) {
      const preSearchedParamsLabels = Object.keys(this.preSearchedParams);
      this.searchParameters.map((searchParameter) => {
        let queryKey = searchParameter.query;
        if (searchParameter.multiDropDownQueryOptions) {
          const selectedDropDown =
            searchParameter.multiDropDownQueryOptions.find(val =>
              preSearchedParamsLabels.includes(val.query),
            );
          queryKey = selectedDropDown && selectedDropDown.query;
        }
        Vue.set(
          this.searchedParams,
          queryKey,
          this.preSearchedParams[queryKey],
        );
        if (this.preSearchedParams.displayLabels && this.preSearchedParams.displayLabels[`${searchParameter.query}_label`]) {
          Vue.set(
            this.displaySearchParams,
            queryKey,
            this.preSearchedParams.displayLabels[`${queryKey}_label`],
          );
        } else {
          Vue.set(
            this.displaySearchParams,
            queryKey,
            this.preSearchedParams[queryKey],
          );
        }
      });
    }
    this.rejectDownload = 0;
    this.loadSearchFromSession();
    this.setDropDownOpenConstants();

    this.selectedLanguage = this.defaultLanguage;
  },
  methods: {
    routeToMdmUploadPage() {
      const routerName = bfrMapper[this.$router.history.current.name] || this.$router.history.current.name;
      localStorage.setItem('mdm-upload-section', routerName);
      this.$router.push({ name: 'Upload',
        params: {
          previousRoute: routerName,
          type: 'mdmV2', // or anything you want,
        } });
    },
    async updateLanguage(val) {
      localStorage.setItem('tsm-shipper-locale', val.id);
      await setLocale(val.id);
    },
    dataToShow(val) {
      if (val && Array.isArray(val) && val.length > 1) {
        if (val[0].length >= 7) {
          return val[0].slice(0, 7).concat('...');
        }
        return val[0].concat(', ...');
      } else if (val.length === 1) {
        return val[0];
      }
      return val;
    },
    dataOnHover(val) {
      if (val && Array.isArray(val) && val.length) {
        return val.join(', ');
      }
      return val;
    },
    save() {
      this.$emit('export');
    },
    setGA(buttonConstant) {
      if (buttonConstant.GAEventConstants) {
        this.$emit('setGA', ...buttonConstant.GAEventConstants);
      }
    },
    loadSearchFromSession() {
      if (!this.enableSearchPopup) {
        const sessionQuery = localStorage.getItem(
          `${this.$route.name}-search-query`,
        );
        if (sessionQuery) {
          this.query = sessionQuery;
        }
        this.search();
      }
    },
    setSearchToSession() {
      if (!this.enableSearchPopup) {
        localStorage.setItem(`${this.$route.name}-search-query`, this.query);
      }
    },
    canShowPermission(button) {
      if (button.config && button.permission && button.childConfigs) {
        const config = this.configurations[button.config][button.childConfigs];
        const permission = this.$hasPermission(button.permission);
        return !!config && permission;
      }
      if (button.config) {
        const buttonConfig = this.configurations[button.config];
        if (button.childConfigs) {
          return button.childConfigs.some(config => buttonConfig[config]);
        }
        return buttonConfig;
      }
      if (button.hidePermission) {
        if (button.feature) {
          return !this.$hasPermission(button.hidePermission) && this.$hasFeature(button.feature);
        }
        return !this.$hasPermission(button.hidePermission);
      } else if (button.permission) {
        if (button.feature) {
          return this.$hasPermission(button.permission) && this.$hasFeature(button.feature);
        }
        return this.$hasPermission(button.permission);
      }
      if (button.id === 'export') {
        if (button.dropdownList && button.dropdownList.length) {
          const buttons = button.dropdownList.filter(
            dropdownItem =>
              dropdownItem.type === 'export' &&
              this.$hasPermission(dropdownItem.permission),
          );
          return buttons.length;
        }
      }

      return true;
    },
    getButtonDropdownlist(button) {
      return button.dropdownList.filter(
        dropdownItem =>
          (dropdownItem.type === 'upload' &&
            (!dropdownItem.permission ||
              this.isPermissionEnabled(dropdownItem.permission))) ||
          (dropdownItem.type === 'export' &&
            (!dropdownItem.permission ||
              this.$hasPermission(dropdownItem.permission))) ||
          (dropdownItem.type === 'link' &&
            this.hasConfiguration(dropdownItem, button.parentConfig)) ||
          (dropdownItem.type === 'button' && (!dropdownItem.feature ||
          this.$hasFeature(dropdownItem.feature))),
      );
    },
    isPermissionEnabled(permission) {
      if (Array.isArray(permission)) {
        return permission.every(_permission => this.$hasPermission(_permission));
      }
      return this.$hasPermission(permission);
    },
    toggleButton(id) {
      const obj = {};
      obj[id] = !this.dropdownOpen[id];
      this.dropdownOpen = Object.assign({}, this.dropdownOpen, obj);
    },
    setDropDownOpenConstants() {
      this.dropdownOpen = {};
      this.buttonsList &&
        this.buttonsList.forEach((val) => {
          if (val.dropdownList) {
            this.dropdownOpen[val.id] = false;
          }
        });
    },
    hasConfiguration(value, parentConfig) {
      let configForUser = this.configurations;
      if (parentConfig) {
        configForUser =
          this.configurations && this.configurations[parentConfig];
      }
      return configForUser && configForUser[value.config];
    },
    getRouterLink(value) {
      let routerLink = { name: value.routerLinkName };
      if (value.params) {
        routerLink = Object.assign(routerLink, { params: value.params });
      }
      if (value.queryParams) {
        routerLink = Object.assign(routerLink, { query: value.queryParams });
      }
      return routerLink;
    },
    unCheck(value) {
      this[value] = null;
    },
    getTagByName(name) {
      let tagConstant = this.searchParameters.find((param) => {
        if (param.multiDropDownQueryOptions) {
          return param.multiDropDownQueryOptions.find(
            val => val.query === name,
          );
        }
        return param.query === name;
      });
      if (tagConstant && tagConstant.multiDropDownQueryOptions) {
        tagConstant = tagConstant.multiDropDownQueryOptions.find(
          val => val.query === name,
        );
      }
      const tagName = tagConstant && tagConstant.name;
      const tagTranslateName = tagConstant && tagConstant.tname;
      return tagTranslateName ? this.$t(tagTranslateName) : tagName;
    },
    removeParamTag(tag) {
      this.unCheck(tag);
      this.searchedParams[tag] = null;
      this.displaySearchParams[tag] = null;
      this.displayLabels[`${tag}_label`] = null;
      this.searchedParams = { ...this.searchedParams };
      if (this.$route.name === 'TrackDashboard') {
        this.searchByParameter({ query: this.searchedParams,
          queryLabels: this.displaySearchParams,
          displayLabels: this.displayLabels });
      } else {
        this.searchByParameter(this.searchedParams);
      }
    },
    searchByParameter(queryArgs, isReset = false) {
      const { query, queryLabels, displayLabels } = queryArgs;
      this.displayLabels = (displayLabels && queryLabels && query) ? displayLabels : {};
      const queryData = (displayLabels && queryLabels && query) ? query : queryArgs;
      const queryCleaned = Object.fromEntries(
        Object.entries(queryData).filter(([key, value]) => value !== ''),
      );
      const searchList = Object.keys(queryCleaned);
      searchList.forEach((value) => {
        if (queryCleaned[value]) {
          const searchTerm = this.searchParameters.find((param) => {
            if (param.multiDropDownQueryOptions) {
              return param.multiDropDownQueryOptions.find(
                val => val.query === name,
              );
            }
            return param.query === name;
          });
          const serachName = (searchTerm && searchTerm.name) || '';
          const searchKey = serachName.replace(/\b[a-zA-Z]/g, match =>
            match.toUpperCase(),
          );
          this.$emit('setGA', 'Textbox', `Search By ${searchKey}`);
        }
      });
      // used to display the searched queries when the pop up is reopened
      this.searchedParams = queryCleaned;
      this.displaySearchParams = queryLabels || queryCleaned;
      if (this.$route.name === 'TrackDashboard') {
        this.$emit('searchByParameter', { query: queryData, displayLabels });
      } else {
        this.$emit('searchByParameter', queryCleaned);
      }
      if (!isReset) {
        this.closePopup();
      }
    },
    onClick() {
      this.focusSearch = false;
      if (this.enableSearchPopup) {
        this.showPopup = true;
        this.$emit('setGA', 'Click', 'Search Button');
      }
    },
    closePopup() {
      this.showPopup = false;
    },
    search: debounce(function debounceSearch() {
      this.setSearchToSession();
      this.$emit('search', this.query);
    }, 500),
    onChangeOption(data) {
      const list = [
        'OutboundIndents',
        'InboundIndents',
        'Dashboard',
        'EximMasterIndent',
        'Admin',
      ];
      if (
        list.includes(this.$router.history.current.name) &&
        data.id !== 'LiveDashboard'
      ) {
        this.$emit('changeCategory', data);
      } else {
        const routerId = bfrMapper[data.id] || data.id;
        this.$router.push({ name: routerId });
      }
    },
    getClass(button) {
      let className = button.class;
      if (button.disabled) {
        className = className.concat(' disablebtn ');
      }
      return className;
    },
    handleFileUpload(emitMethod) {
      this.file = this.$refs[emitMethod][0].files[0];
      this.$emit(emitMethod, this.file);
      // Reset the uploaded file value
      const input = this.$refs[emitMethod][0];
      input.type = 'file';
      input.value = null;
      this.$emit('setGA', 'Click', bulkUploadList[emitMethod], 'bulk upload');
    },
  },
};
</script>
<style lang="scss">
@import '~@common/styles-shipper/settings';
$fontSemibold: 'OpenSans-Semibold';
$fontBold: 'OpenSans-Bold';
.primary-filter {
  border: 1px solid #e9f1f5;
  background-color: #fff;
  height: 50px;
  font-family: $fontSemibold;
  .dropdown-menu {
    top: 32px !important;
  }
  .filter-grid {
    padding-left: 0;
    padding-right: 0;
    ul {
      list-style: none;
      .app-side-menu {
        padding: 14px 0;
        width: 69px;
        text-align: center;
        position: relative;
        top: -2px;
        cursor: pointer;
      }
      .category {
        color: #fff;
        font-size: 1.4rem;
        text-transform: uppercase;
        margin-left: -3px;
        position: relative;
        top: -1px;
        height: 49px;
        .dropdown {
          min-width: 200px;
        }
      }
      .search {
        padding: 0 20px;
        width: 50%;
        svg {
          position: relative;
          top: 0px;
        }
        input {
          outline: none;
          border: 1px solid transparent;
          padding: 0 5px;
          width: 90%;
          font-size: 1.4rem;
        }
      }
    }
    &.filter-button {
      ul {
        @extend %list-unstyled;
        float: right;
        padding: 9.5px 10px;
        li {
          margin: 0 0 0 18px;
          &:last-child {
            margin: 0 0 0 10px;
          }
          .btn-primary {
            @extend %header-primary-btn;
            @extend %bold;
            color: #fff;
            text-transform: uppercase;
          }
          .btn-secondary {
            @extend %header-secondary-btn;
            @extend %bold;
            color: #008aff;
            text-transform: uppercase;
          }
        }
      }
    }
  }
}
.border-dark {
  .categoryselect {
    border-color: #121e2d;
  }
}
.select_options {
  a {
    text-decoration: none;
  }
}
.action {
  text-decoration: none;
}
.inboundbutton {
  width: 142px !important;
}
.inbounddropdown.el-dropdown-menu.el-popper {
  width: 142px !important;
}
.inbounddropdown .el-dropdown-menu__item {
  margin: 0 0 0 0px !important;
  padding: 5px 10px !important;
}
</style>
